<template>
    <rkm-modal
        :loading="loading"
        ref="RkmModal"
        title="Selecione o local"
    >
        <rkm-form ref="RkmForm">
            <rkm-row 
                class="text-center salas-grid"
            >
                <rkm-col
                    v-for="sala in salas"
                    :key="sala.id"
                    class="sala-col"
                >
                    <rkm-button
                        @click="store(sala.id)"
                        block
                        color="primary"
                        class="sala-button"
                    >
                        {{ sala.nome }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <div v-if="salas.length === 0" class="text-center text-muted py-4">
                Nenhum local disponível para chamada
            </div>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close" color="secondary">
                Cancelar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import {error, repository, stringCase} from '@/mixins'
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            chamada: this.getConectaSusRepository('painelSenha.chamada')
        }
    },
    data: () => ({
        filaId: null,
        telaId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(filaId, telaId) {
            this.filaId = filaId
            this.telaId = telaId
            this.$refs.RkmModal.show()
        },
        store(salaId) {
            const request = {
                filaId: this.filaId,
                telaId: this.telaId,
                salaId: salaId,
            }

            this.setLoading()
            this.repositories.chamada.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => this.close())
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        salas: {type: Array, required: true},
    },
}
</script>

<style scoped>
.salas-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
    justify-items: center;
    align-items: center;
}

.sala-col {
    flex: 1 1 200px;
    max-width: 200px;
}

.sala-button {
    margin-bottom: 5px;
    white-space: normal;
    height: 70px;
    font-size: 14px;
    padding: 8px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>